<!--
 * @Version      : V1.0
 * @Date         : 2025-05-21 09:27:24
 * @fileName     :
 * @Description  : 我的用印
-->
<template>
  <div class="customerProfile-con px-20 py-20 border-box">
    <el-card class="box-card">
      <div class="query-con">
        <el-form :inline="true" :model="formInline" ref="ruleForm" class="demo-form-inline">
          <!-- <el-form-item label="项目名称" porp="projectName">
            <el-input v-model="formInline.projectName" placeholder="项目名称"></el-input>
          </el-form-item>
          <el-form-item label="收款合同名称" porp="contractReceivePaymentName">
            <el-input v-model="formInline.contractReceivePaymentName" placeholder="收款合同名称"></el-input>
          </el-form-item> -->
          <el-form-item label="关联项名称" porp="correlationName">
            <el-input v-model="formInline.correlationName" placeholder="关联项名称"></el-input>
          </el-form-item>
          <el-form-item label="项目类型">
            <!--项目 -->
            <el-select clearable v-model="queryForm.projectTypeCode" placeholder="请选择项目类型">
              <el-option v-for="item in projectOption" :key="item.dictValue" :label="item.dictLabel"
                :value="item.dictValue">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="用印单位">
            <el-select clearable v-model="queryForm.useSealOwnerUnitId" placeholder="请选择用印单位">
              <el-option v-for="item in useSealOwnerUnitOption" :key="item.id" :label="item.unitName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryData">查询</el-button>
            <el-button @click="resetData('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <div class="operate py-20 border-box">
      <el-button type="success" @click="addItem()">新增</el-button>
      <!-- <el-button type="primary">导出</el-button>
      <el-button type="primary">导入</el-button> -->
    </div>
    <div class="table-con">
      <tableComponent :columns="columns" :tableData="dataList" @preSizeChange="childSizeChange"
        @preCurrentChange="childCurrentChange" :loading="loading" :pagination="pagination">

        <template #sealStatusSlot="{ row }">
          <div>
            <el-tag :type="formatterState(row.sealStatus, 'contract').type" effect="dark">{{
              formatterState(row.sealStatus, 'contract').text }}</el-tag>
          </div>
        </template>
        <template #operate="{ row }">
          <div>
            <el-button type="text" @click="details(row)">详情</el-button>
            <el-button type="text" @click="withdraw(row)" v-if="row.sealStatus == 1">撤销</el-button>
            <el-button type="text" @click="edit(row)" v-if="row.sealStatus == 3 || row.sealStatus == 0 || row.sealStatus == 9">修改</el-button>
            <el-button type="text" @click="removeItem(row)" style="color:#F56C6C;"
              v-if="row.sealStatus == 0 || row.sealStatus == 9">删除</el-button>
          </div>
        </template>
      </tableComponent>
    </div>
    <my-contract-details ref="myComtractRefs" @initQueryData="queryData" :title="detailsT"
      :status="preStatus"></my-contract-details>
  </div>
</template>

<script>
import myContractDetails from './components/myContractDetails.vue'
import tableComponent from '@/components/tableComponent/index.vue'
import { formatterState } from '@/utils/index'
import { queryBasicOwnersListApi } from '@/api/basicInfo/index'
import { querySealApplicationApi, deleteSealApplicationApi, withdrawSealApplicationApi } from '@/api/sealApplication/index'
import { dataPage } from "@/api/sys/dictData";
export default {
  components: {
    tableComponent,
    myContractDetails
  },
  data() {
    return {
      loading: false,
      dialogFormVisible: false,
      detailsT: '我的用印详情',
      formInline: {
        projectName: "",
        contractReceivePaymentName: "",
        correlationName: ""
      },
      queryForm: {
        projectTypeCode: "",
        useSealOwnerUnitId: ""
      },
      dataList: [],
      useSealOwnerUnitOption: [],
      preStatus: '',
      columns: [
        {
          id: 0,
          title: "序号", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "68px",
          keyName: "i", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        // {
        //   id: 1,
        //   title: "用印编号", // 标题名称
        //   isSort: false, // 是否展示排序按钮
        //   sortState: "",
        //   width: "120px",
        //   keyName: "contractName", // 数据的属性值
        //   align: "left",
        //   slotName: "", // 插槽名,为空字符串时不使用
        // },
        {
          id: 2,
          title: "关联项名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "180px",
          keyName: "correlationName", // 数据的属性值
          align: "left",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 4,
          title: "项目类型", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "projectTypeName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 5,
          title: "关联金额(元)", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "correlationAmount", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 6,
          title: "客户名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "120px",
          keyName: "customerName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 7,
          title: "申请部门", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "120px",
          keyName: "applicationDeptName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 8,
          title: "用印文件", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "useSealDocumentName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 9,
          title: "用印事由", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "120px",
          keyName: "useSealReason", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 10,
          title: "文件数量", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "documentCount", // 数据的属性值
          align: "right",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 11,
          title: "文件类型", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "documentTypeName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 12,
          title: "用印种类", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "affixedOfficialSealTypeName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 13,
          title: "用印单位", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "useSealOwnerUnitName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 14,
          title: "提交人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "70px",
          keyName: "createByName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 15,
          title: "创建日期", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "145px",
          keyName: "createTime", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 16,
          title: "用印状态", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "sealStatus", // 数据的属性值
          align: "center",
          slotName: "sealStatusSlot", // 插槽名,为空字符串时不使用
        },
        {
          id: 17,
          title: "操作", // 标题名称
          fixed: "right",
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "150px",
          keyName: "", // 数据的属性值
          align: "left",
          slotName: "operate", // 插槽名,为空字符串时不使用
        }
      ],
      pagination: {
        pageCount: 7, //总页数
        total: 0, //总条目数
        pageSize: 1,//当前页条数
        pageSizes: [10, 20, 100]
      },
      projectOption: []
    }
  },
  mounted() {
    this.dictOption('project_type');
    this.getOwnersList()
    this.queryData()
  },
  methods: {
    formatterState,
    //查询
    queryData() {
      this.initData()
    },
    //初始化查询
    initData(item = {}) {
      let params = {
        pageNum: "1",
        pageSize: "10",
        query: {
          params: {
            projectName: "",
            contractReceivePaymentName: "",
            correlationName: "",
            ...this.formInline
          },
          projectTypeCode: "",//项目类型code 字典: project_type
          useSealOwnerUnitId: "",//用印单位ID
          ...this.queryForm
        },
        ...item
      }
      this.loading = true;
      querySealApplicationApi(params).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.dataList = res.data.rows;
          this.pagination.total = res.data.total;
        }
      })
    },
    childSizeChange(page) {
      this.initData({ pageSize: page })
    },
    childCurrentChange(value) {
      this.initData({ pageNum: value })
    },
    //重置搜索form
    resetData(formName) {
      this.formInline.projectName = "";
      this.formInline.contractReceivePaymentName = "";
      this.formInline.correlationName = ""
      this.queryForm.projectTypeCode = "";
      this.queryForm.useSealOwnerUnitId = "";
      this.$nextTick(() => {
        this.initData()
      })
    },
    addItem() {
      this.preStatus = 'add'
      this.detailsT = '我的用印新增'
      this.$refs.myComtractRefs.openDrawer({})
    },
    details(row) {
      this.preStatus = 'view'
      this.detailsT = '我的用印详情'
      this.$refs.myComtractRefs.openDrawer(row)
    },
    edit(row) {
      this.preStatus = 'edit'
      this.detailsT = '我的用印编辑'
      this.$refs.myComtractRefs.openDrawer(row)
    },
    removeItem(row) {
      this.$confirm('确定要删除该用印？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.loading = true;
        deleteSealApplicationApi({ id: row.id }).then(res => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: 'success'
            });
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
          this.loading = false;
          this.initData()
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    withdraw(row) {
      this.$confirm('确定要撤销该用印申请？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.loading = true;
        withdrawSealApplicationApi({ id: row.id }).then(res => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: 'success'
            });
          } else {
            this.$message({
              message: res.msg,
              type: 'warning'
            });
          }
          this.loading = false;
          this.initData()
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    async dictOption(type) {
      let params = {
        query: {
          dictType: type
        }
      }
      dataPage(params).then(res => {
        if (res.code == 200) {
          this.projectOption = res.data.rows || []
        }
      })
    },
    //用印单位
    getOwnersList() {
      let params = {
        unitName: ""
      }
      queryBasicOwnersListApi(params).then(res => {
        if (res.code == 200) {
          this.useSealOwnerUnitOption = res.data;

        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.customerProfile-con {
  background: #f7f4f4;

  .box-card {
    width: 100%;
  }

  .operate {}
}
</style>
